import OrDivider from './OrDivider'

export default OrDivider
